import {
  CreditCard,
  LayoutDashboard,
  ListOrdered,
  Bell,
  Mail,
  Megaphone,
  MessageSquare,
  Newspaper,
  PartyPopper,
  Presentation,
  SwatchBook,
  Trophy,
  Users,
  type LucideIcon,
} from "lucide-react";
import type { EnglishMessages } from "@/i18n/english-messages";

type SidebarMessages = EnglishMessages["Sidebar"];

export type AdminNavLabelKey = Extract<
  keyof SidebarMessages,
  | "adminDashboard"
  | "adminAwardShows"
  | "adminParties"
  | "adminSamples"
  | "adminPartnerReports"
  | "adminBilling"
  | "adminBlog"
  | "adminUsers"
  | "adminAnnouncements"
  | "adminNotifications"
  | "adminContact"
  | "adminFeedback"
  | "adminWaitlist"
>;

export type AdminNavLink = {
  href: `/${string}`;
  labelKey: AdminNavLabelKey;
  icon: LucideIcon;
};

export const ADMIN_NAV_LINKS: readonly AdminNavLink[] = [
  { href: "/admin", labelKey: "adminDashboard", icon: LayoutDashboard },
  { href: "/admin/award-shows", labelKey: "adminAwardShows", icon: Trophy },
  { href: "/admin/parties", labelKey: "adminParties", icon: PartyPopper },
  { href: "/admin/samples", labelKey: "adminSamples", icon: SwatchBook },
  {
    href: "/admin/partner-reports",
    labelKey: "adminPartnerReports",
    icon: Presentation,
  },
  { href: "/admin/billing", labelKey: "adminBilling", icon: CreditCard },
  { href: "/admin/blog", labelKey: "adminBlog", icon: Newspaper },
  { href: "/admin/users", labelKey: "adminUsers", icon: Users },
  { href: "/admin/announcements", labelKey: "adminAnnouncements", icon: Megaphone },
  { href: "/admin/notifications", labelKey: "adminNotifications", icon: Bell },
  { href: "/admin/contact", labelKey: "adminContact", icon: Mail },
  { href: "/admin/feedback", labelKey: "adminFeedback", icon: MessageSquare },
  { href: "/admin/waitlist", labelKey: "adminWaitlist", icon: ListOrdered },
];

export function getAdminNavHrefs(): string[] {
  return ADMIN_NAV_LINKS.map((link) => link.href);
}
